window.pollen = {
    searchValue: null,
    regionSelectEl: document.getElementById('pollen-region-select'),
    citySelectEl: document.getElementById('pollen-city-select'),
    cityDivEl: document.getElementById('pollen-search'),
    isRegionPage: !!document.getElementById('pollen-region-select'),
    isCityPage: document.getElementById('pollen-search') ? document.getElementById('pollen-search').hasAttribute('data-value'): false,
    breezoMeterAPIKey: window.breezometerAPIKey,
    googlePollenApi: window.googleApiKey,
    map: null,
    bbox: null,
    userLocation: {
        lat: window.defaultUserLocation.lat,
        lng: window.defaultUserLocation.lng
    },
    regionLocation: null,
    cityLocation: null,
    threshold: ['80', '64', '48', '32', '16', '0'],
    colorCodes: ['#E6E6E6', '#a4c400', '#51B33B', '#FFFD2D', '#FD7D1D', '#FB0015'],
    tile: 'tree',
    params: Object.fromEntries(new URLSearchParams(window.location.search).entries()),
    isMobile: window.innerWidth < 768,
    isTablet: window.innerWidth >= 768 && window.innerWidth < 1200,
    curLang: localStorage.selectedLanguage,
    // geocoder: new google.maps.Geocoder(),
    async init() {

        if (document.querySelector('.pollen-header-main')) {
            // document.querySelector('header')
            window.onclick = (event)=> {
                console.log(event.target);
                if (event.target.classList.contains("pollen-header-title")) {
                    document.getElementById("pollen-header-search").classList.remove("d-none");
                    document.getElementById("pollen-header-title").classList.add("opacity-0");
                    document.getElementById("pollen-header-title").setAttribute('style', 'height: 0;');
                }
                else if (!document.getElementById("pollen-header-title").classList.contains("d-none") && !event.target.classList.contains("mapboxgl-ctrl-geocoder--input")) {
                    document.getElementById("pollen-header-search").classList.add("d-none");
                    document.getElementById("pollen-header-title").classList.remove("opacity-0");
                    document.getElementById("pollen-header-title").setAttribute('style', 'height: auto;');
                }
                if (event.target.classList.contains("pollen-header-title-mob")) {
                    document.getElementById("pollen-header-search-mob").classList.remove("d-none");
                    document.getElementById("pollen-header-title-mob").classList.add("opacity-0");
                }
                else if (!document.getElementById("pollen-header-title-mob").classList.contains("d-none") && !event.target.classList.contains("mapboxgl-ctrl-geocoder--input")) {
                    document.getElementById("pollen-header-search-mob").classList.add("d-none");
                    document.getElementById("pollen-header-title-mob").classList.remove("opacity-0");
                }
            }
            if(this.getCookie('pollenHeaderValue') != '' && this.getCookie('pollenHeaderValue') != null && this.getCookie('pollenHeaderValue') != 'pollenHeaderValue') {
                var pollenHeaderValue =  this.getCookie('pollenHeaderValue');
            }
            else {
                var pollenHeaderValue = localStorage.getItem('pollenHeaderValue');
            }
        
            if(pollenHeaderValue){
        
                document.getElementById('link-pollen-forcast').setAttribute('href', this.getPollenTranslation('pageUrl'));
                // ?search=${pollenHeaderValue}
                document.getElementById('pollen-address-title').innerText = `${pollenHeaderValue}`;

                document.getElementById('link-pollen-forcast-mob').setAttribute('href', this.getPollenTranslation('pageUrl'));
                // ?search=${pollenHeaderValue}
                document.getElementById('pollen-address-title-mob').innerText = `${pollenHeaderValue}`;
                // document.getElementById('data-top-bar').classList.remove('d-none');
            }
            else {

                try {
                //ip stack update
                    const response = await fetch(`https://api.ipstack.com/check?access_key=771c7cd15b294eb19b2e29264ff2b8c2&language=${this.curLang}`);
                    const data = await response.json();

                    if (data.country_name !== window.countryName) {
                        data.latitude = window.defaultUserLocation.lat;
                        data.longitude = window.defaultUserLocation.lng;
                        data.city = window.defaultCity;
                        data.country_name = window.countryName;
                    }

                    this.userLocation = {
                        lat: data.latitude,
                        lng: data.longitude,
                    };

                    this.setCookie('userLocationLat', parseFloat(data.latitude).toFixed(8), 30);
                    this.setCookie('userLocationLng', parseFloat(data.longitude).toFixed(8), 30);
                    this.setCookie('userLocationCity', data.city, 30);
                    this.setCookie('userLocationCountry', data.country_name, 30);
                    userLocationLat = data.latitude;
                    userLocationLng = data.longitude;
                    userLocationCity = data.city;
                    userLocationCountry = data.country_name;

                    let pollenHeaderValue = `${data.city}, ${data.country_name}`;
                    document.getElementById('link-pollen-forcast').setAttribute('href', this.getPollenTranslation('pageUrl'));
                    // ?search=${pollenHeaderValue}
                    document.getElementById('pollen-address-title').innerText = `${pollenHeaderValue}`;

                    document.getElementById('link-pollen-forcast-mob').setAttribute('href', this.getPollenTranslation('pageUrl'));
                    // ?search=${pollenHeaderValue}
                    document.getElementById('pollen-address-title-mob').innerText = `${pollenHeaderValue}`;

                    this.setCookie('pollenHeaderValue', pollenHeaderValue, 30);
                    

                } catch (e) {
                    this.userLocation = {
                        lat: window.defaultUserLocation.lat,
                        lng: window.defaultUserLocation.lng,
                    };
                    
                    let pollenHeaderValue = `${window.defaultCity}, ${window.countryName}`;
                    
                    this.setCookie('pollenHeaderValue', pollenHeaderValue, 30);
                    this.setCookie('userLocationLat',  window.defaultUserLocation.lat, 30);
                    this.setCookie('userLocationLng',  window.defaultUserLocation.lng, 30);
                    this.setCookie('userLocationCity', window.defaultCity, 30);
                    this.setCookie('userLocationCountry', window.countryName, 30);

                    document.getElementById('link-pollen-forcast').setAttribute('href', this.getPollenTranslation('pageUrl'));
                    // ?search=${pollenHeaderValue}
                    document.getElementById('pollen-address-title').innerText = `${pollenHeaderValue}`;

                    document.getElementById('link-pollen-forcast-mob').setAttribute('href', this.getPollenTranslation('pageUrl'));
                    // ?search=${pollenHeaderValue}
                    document.getElementById('pollen-address-title-mob').innerText = `${pollenHeaderValue}`;

                    console.error('IP stack API failed', e);
                }
            }
        
            this.geocoder = new MapboxGeocoder({
                accessToken: window.mapBoxAPIKey,
                types: 'country,region,place,postcode,locality,neighborhood',
                countries: 'CH',
                language: this.curLang,
                placeholder: this.getPollenTranslation('placeHolder'),
            });
            if(!this.isMobile && !this.isTablet) {
                this.geocoder.addTo('#pollen-header');
            }
            else {
                this.geocoder.addTo('#pollen-header-mob');
            }            
            // this.geocoder._inputEl.value = this.searchValue;
        
            this.geocoder.on('result', async (e) => {
                let result = e.result;
                let type = result.id.split('.')[0];
                let city = '';
                let countryObj = result.context.find(c => c.id.includes('country'));
                let country = countryObj ? countryObj.text : '';
        
                let placeNameArr = result.place_name.split(',');
                if (placeNameArr.length > 1) {
                    city = placeNameArr[0];
                } else if (placeNameArr.length === 1) {
                    city = placeNameArr[0].split(' ')[0];
                }
        
                this.setCookie('userLocationLng', result.center[0], 30);
                this.setCookie('userLocationLat', result.center[1], 30);
                this.setCookie('userLocationCity', city, 30);
                this.setCookie('userLocationCountry', country, 30);
                this.setCookie('pollenHeaderValue_type', type, 30);
                this.setCookie('pollenHeaderValue', result.place_name, 30);
                
                window.location.href = this.getPollenTranslation('pageUrl');
            });
        }

        if (!document.getElementById('pollen-counter-block')) return;

        if (!(this.isRegionPage || this.isCityPage)) this.searchValue = this.params.search;

        await this.setRegionLocation();
        await this.setCityLocation();

        if (!(this.isRegionPage || this.isCityPage)) {

            if (!this.searchValue) await this.setUserLocation();
            else if(this.searchValue == pollenHeaderValue) await this.setUserLocation();
            else await this.setSearchLocation();

            // await this.setHeaderSearchBox();
        }

        await this.setSearchBox();

        this.map = new mapboxgl.Map({
            attributionControl: false,
            dragPan: true, // Disable one-finger drag on all devices
            dragRotate: false,
            touchPitch: false, // Disable one-finger drag on mobile devices, allow two-finger drag
            showCompass: false,
            cooperativeGestures: true,
            accessToken: window.mapBoxAPIKey,
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [this.userLocation.lng, this.userLocation.lat],
            zoom: window.defaultZoom,
            maxBounds: [[window.countryBounds.west, window.countryBounds.south], [window.countryBounds.east, window.countryBounds.north]]
        });

        this.map.addControl(new mapboxgl.NavigationControl( {showCompass: false} ), 'bottom-right');

        this.bindEvents();

        await this.updatePollenForecastData();

        let vr = this.map.getBounds();
        let north = vr.getNorth();
        let south = vr.getSouth();
        let east = vr.getEast();
        let west = vr.getWest();
        let bounds = {north: north, east: east, south: south, west: west};
        this.bbox = [[bounds.east, bounds.south], [bounds.west, bounds.north]];

        await this.updateHeatMap();
        await this.updateWeatherForecastData();

        document.querySelectorAll('.shopify-section.section-spacing').forEach((divEl, index) => {

            if (index === 0) divEl.classList.add('pollen-section');

            if (index === 1) divEl.classList.add('Var-section');

        });

        document.getElementById('pollen-search-form').addEventListener('submit', async (event) => {
            event.preventDefault();
        });

        document.getElementById('reset-pollen-search').addEventListener('click', ()=> {
            document.querySelector('#pollen-search .mapboxgl-ctrl-geocoder--input').value = ``;
            document.querySelector('#pollen-search .mapboxgl-ctrl-geocoder--input').focus();
        });
        
    },
    async setSearchBox() {
        this.geocoder = new MapboxGeocoder({
            accessToken: window.mapBoxAPIKey,
            types: 'country,region,place,postcode,locality,neighborhood',
            countries:'CH',
            language: this.curLang,
            placeholder: this.getPollenTranslation('placeHolder'),
        });
        this.geocoder.addTo('#pollen-search');
        this.geocoder._inputEl.value = this.searchValue;

        this.geocoder.on('result', async (e) => {

            let result = e.result;
            let type = result.id.split('.')[0];
            this.userLocation.lng = result.center[0];
            this.userLocation.lat = result.center[1];
            this.bbox = result.bbox;

            document.querySelector('#pollen-search .mapboxgl-ctrl-geocoder--input').blur();

            if(this.isCityPage || this.isRegionPage) {

                let city = '';
                let countryObj = result.context.find(c => c.id.includes('country'));
                let country = countryObj ? countryObj.text : '';        
                let placeNameArr = result.place_name.split(',');
                if (placeNameArr.length > 1) {
                    city = placeNameArr[0];
                } else if (placeNameArr.length === 1) {
                    city = placeNameArr[0].split(' ')[0];
                }

                this.setCookie('userLocationLng', result.center[0], 30);
                this.setCookie('userLocationLat', result.center[1], 30);
                this.setCookie('userLocationCity', city, 30);
                this.setCookie('userLocationCountry', country, 30);
                this.setCookie('pollenHeaderValue_type', type, 30);
                this.setCookie('pollenHeaderValue', result.place_name, 30);
                
                window.location.href = this.getPollenTranslation('pageUrl');
            }
            else{
                try {
                    await this.updatePollenForecastData();
                    await this.updateHeatMap();
                    await this.updateWeatherForecastData();
                    //update header location
                    this.updateHeaderCity(result.place_name, result.center[0], result.center[1], type);
                } catch (error) {
                    console.error(error);
                }

                let arrayProgressStyle = [];
                document.querySelectorAll(`#pollenTab .tab-pane.tabcontent.open .circle-container__progress`).forEach((circleEl) => {

                    let circleAttribute = circleEl.getAttribute('style');
                    arrayProgressStyle.push(circleAttribute);
                    circleEl.setAttribute('style', 'stroke-dashoffset: 80; stroke: #E6E6E6;');
                });
                setTimeout(() => {
                    document.querySelectorAll(`#pollenTab .tab-pane.tabcontent.open .circle-container__progress`).forEach((circleEl, index) => {
                        circleEl.setAttribute('style', arrayProgressStyle[index]);
                    });
                }, 800);
            }

        });
    },

    updateHeaderCity(location, lng, lat, type) {

        this.setCookie('userLocationLng', lng, 30);
        this.setCookie('userLocationLat', lat, 30);

        // this.setCookie('pollenHeaderValue_lat', lat, 30);
        // this.setCookie('pollenHeaderValue_lng', lng, 30);
        this.setCookie('pollenHeaderValue_type', type, 30);
        this.setCookie('pollenHeaderValue', location, 30);
        document.getElementById('link-pollen-forcast').setAttribute('href', this.getPollenTranslation('pageUrl'));
        // ?search=${location}
        document.getElementById('pollen-address-title').innerText = `${location}`;

        document.getElementById('link-pollen-forcast-mob').setAttribute('href', this.getPollenTranslation('pageUrl'));
        // ?search=${location}
        document.getElementById('pollen-address-title-mob').innerText = `${location}`;
    },

    async changeTabsPollen(event) {

        let tab = event.target;
        document.querySelectorAll('.pollen-weather-tab [data-tab]').forEach(tabs => tabs.classList.remove('active'))
        tab.classList.add('active');
        let tabId = tab.getAttribute('data-tab');
        document.querySelectorAll('.main-tabs').forEach(tabs => tabs.classList.add('d-none'))
        document.querySelector(tabId).classList.remove('d-none');

        let tabClass = tabId.slice(1);

        let sourceTextEl = document.querySelector('.source-text');
        let daysTabEl = document.querySelector('.days-tab');
        if (tabClass === 'weatherTab') {
            document.querySelectorAll('.pollenTab').forEach(tabs => tabs.classList.add('d-none'));
            document.querySelectorAll('.weatherTab').forEach(tabs => tabs.classList.remove('d-none'));
            if (sourceTextEl) {
                sourceTextEl.innerHTML = this.getPollenTranslation('source') + ': Google'
            }
            if (daysTabEl) {
                daysTabEl.classList.add('disable-days');
            }
            document.querySelector('.days-tab li:first-child span').click();
        }
        else {

            if (sourceTextEl) {
                sourceTextEl.innerHTML = this.getPollenTranslation('source') +': Google'
            }
            if (daysTabEl) {
                daysTabEl.classList.remove('disable-days');
            }
            let arrayprogressstyle = [];
            document.querySelectorAll(`#pollenTab .tab-pane.tabcontent.open .circle-container__progress`).forEach((circleEl) => {

                let circleAttribute = circleEl.getAttribute('style');
                arrayprogressstyle.push(circleAttribute);
                circleEl.setAttribute('style', 'stroke-dashoffset: 80; stroke: #E6E6E6;');
            });
           
            document.querySelectorAll('.weatherTab').forEach(tabs => tabs.classList.add('d-none'));
            document.querySelectorAll('.pollenTab').forEach(tabs => tabs.classList.remove('d-none'));
            
            setTimeout(() => {
                document.querySelectorAll(`#pollenTab .tab-pane.tabcontent.open .circle-container__progress`).forEach((circleEl, index) => {
                    circleEl.setAttribute('style', arrayprogressstyle[index]);
                });
            }, 200);

        }
    },

    async changeTabs(event) {

        let tab = event.target;
        document.querySelectorAll('.tablink.pollen-pill-tab').forEach(tabs => tabs.classList.remove('open'))
        document.querySelectorAll('.tablink.pollen-pill-tab span.pollen-pill-tab').forEach(tabs => tabs.classList.remove('active'))
        tab.parentElement.classList.add('open');

        let tabId = tab.getAttribute('data-tabcontent');
        document.querySelectorAll('.main-tabs .tab-content .tabcontent').forEach(tabs => tabs.classList.remove('open'));
        let arrayprogressstyle = [];

        document.querySelectorAll(`${tabId} .circle-container__progress`).forEach((circleEl) => {

            let circleAttribute = circleEl.getAttribute('style');
            arrayprogressstyle.push(circleAttribute);
            circleEl.setAttribute('style', 'stroke-dashoffset: 80; stroke: #E6E6E6;');
        });
        document.querySelector(tabId).classList.add('open');
        setTimeout(() => {
            document.querySelectorAll(`${tabId} .circle-container__progress`).forEach((circleEl, index) => {
                console.log(circleEl)
                circleEl.setAttribute('style', arrayprogressstyle[index]);
            });
        }, 200);

    },

    async updateWeatherForecastData() {

        try {
            const weatherParams = new URLSearchParams({
                key: this.googlePollenApi,
                'location.latitude': this.userLocation.lat,
                'location.longitude': this.userLocation.lng,
                languageCode: this.curLang
            });

            let response = await fetch(`https://weather.googleapis.com/v1/currentConditions:lookup?${weatherParams}`);
            response = await response.json();

            if (response && !response.error) {

                document.querySelector('[data-temperature]').innerText = response.temperature?.degrees?.toFixed(0) + '°';
                document.querySelector('[data-temperature-feels]').innerText = this.getPollenTranslation('feelsLike') + response.feelsLikeTemperature?.degrees?.toFixed(0) + '°';
                document.querySelector('[data-humidity]').innerText = response.relativeHumidity.toFixed(0) + '%';
                document.querySelector('[data-wind]').innerText = ((response.wind?.speed?.value * 1000) / 3600).toFixed(0) + 'm/s';
                document.querySelector('[data-wind-arrow]').style = `transform: rotate(${response.wind?.direction?.degrees + 48}deg)`;
            }
        } catch (e) {
            console.error(e);
            Rollbar.error("Weather API failed");
        }
    },

    async updatePollenForecastData() {

        this.tile = document.querySelector('[name="heatmap-pollen-type"]:checked').value;
        const pollenParams = new URLSearchParams({
            key: this.googlePollenApi,
            'location.latitude': this.userLocation.lat,
            'location.longitude': this.userLocation.lng,
            days: 3,
            languageCode: this.curLang
        });
        try {
            let response = await fetch(`https://pollen.googleapis.com/v1/forecast:lookup?${pollenParams}`);
            response = await response.json();

            document.querySelector('.text-danger')?.remove();
            if (response.dailyInfo) {
                response.dailyInfo.forEach((forecastDayData, index) => {
                    let date = `${forecastDayData.date.year}/${forecastDayData.date.month}/${forecastDayData.date.day}`;
                    if (index === 2) {

                        let weekday = [
                            this.getPollenTranslation('Sunday'), 
                            this.getPollenTranslation('Monday'), 
                            this.getPollenTranslation('Tuesday'), 
                            this.getPollenTranslation('Wednesday'), 
                            this.getPollenTranslation('Thursday'), 
                            this.getPollenTranslation('Friday'), 
                            this.getPollenTranslation('Saturday')
                        ];
                        document.querySelector('[data-day-after-tomorrow]').innerHTML = weekday[new Date(date).getDay()];
                    }
                    this.setPollenTypeData(forecastDayData.pollenTypeInfo, index + 1)
                    this.setPollenAllergenData(forecastDayData.plantInfo, index + 1)
                });
            } else {
                // this.searchEl.insertAdjacentHTML('afterend', '<p class="error text-danger">' + response.error + '</p>')
            }
        } catch (e) {
            console.error(e);
            Rollbar.error("Pollen API failed");
        }
    },

    setPollenTypeData(data, dayIndex) {
        document.querySelectorAll(`#pollen-${dayIndex} .circle-container__progress`).forEach(progress => progress.setAttribute('style', `stroke-dashoffset: ${this.threshold[0]}; stroke: ${this.colorCodes[0]};`))

        let pollenView = document.getElementById(`pollen-${dayIndex}`);

        data.forEach((typeData) => {
            let type = typeData.code;
            type = type.toLowerCase();
            let strokeValue = typeData.indexInfo?.value || 0;
            //   let temp = [0, 1, 2, 3, 4, 5];
            //   strokeValue = temp[Math.floor(Math.random() * temp.length)];

            let CircleDisplayName = ' ';
            switch (this.colorCodes[strokeValue]) {
                case '#E6E6E6':
                    CircleDisplayName = this.getPollenTranslation('NoValues');
                    break;
                case '#a4c400':
                    CircleDisplayName = this.getPollenTranslation('VeryLow');
                    break;
                case '#51B33B':
                    CircleDisplayName = this.getPollenTranslation('low');
                    break;
                case '#FFFD2D':
                    CircleDisplayName = this.getPollenTranslation('medium');
                    break;
                case '#FD7D1D':
                    CircleDisplayName = this.getPollenTranslation('high');
                    break;
                case '#FB0015':
                    CircleDisplayName = this.getPollenTranslation('veryHigh');
                    break;
                default:
                    CircleDisplayName = ' ';

            }
            pollenView.querySelectorAll(`[data-${type}] .pollen-type-tree-level-label`).forEach((labelEl) => {
                labelEl.innerText = CircleDisplayName;
            });
            pollenView.querySelector(`[data-${type}] .circle-container__progress`).setAttribute('style', `stroke-dashoffset: ${this.threshold[strokeValue]}; stroke: ${this.colorCodes[strokeValue]};`)
        })
    },

    setPollenAllergenData(data, dayIndex) {
        let pollenView = document.getElementById(`pollen-${dayIndex}`);

        pollenView.querySelector('[data-pollen-allergens]').innerHTML = '';

        let planHtml = ``;

        data.forEach((allergenData) => {
            let strokeValue = allergenData.indexInfo?.value || 0;
            console.log(strokeValue, 'stroke');
            //   let temp = [0, 1, 2, 3, 4, 5];
            //   strokeValue = temp[Math.floor(Math.random() * temp.length)];

            let plateDisplayName = allergenData.displayName;
            planHtml += `<div class='levels-data'><span style='background-color: ${this.colorCodes[strokeValue]};'></span>${plateDisplayName}</div>`;
        })

        pollenView.querySelector('[data-pollen-allergens]').innerHTML = planHtml;
    },

    updateHeatMap() {

        this.map.fitBounds(this.bbox);
        let tile = this.tile?.toUpperCase();
        this.changeOverlay(`https://pollen.googleapis.com/v1/mapTypes/${tile}_UPI/heatmapTiles/{z}/{x}/{y}?key=${this.googlePollenApi}`)
    },

    changeOverlay(tileURL) {

        let currentLayer = this.map.getLayer('breezometer-tiles');
        if (currentLayer) {

            this.map.removeLayer('breezometer-tiles');
            this.map.removeSource('breezometer-tiles');
        }

        this.map.addSource('breezometer-tiles', {
            type: 'raster',
            tiles: [tileURL],
            tileSize: 256,
            maxzoom: 1
        });

        this.map.addLayer({
            id: 'breezometer-tiles',
            type: 'raster',
            source: 'breezometer-tiles',
            minzoom: 0,
            maxzoom: 22,
            paint: {
                'raster-opacity': 0.6
            }
        });
    },

    async setUserLocation() {
        if(this.getCookie('userLocationLat') != '' && this.getCookie('userLocationLat') != null && this.getCookie('userLocationLat') != 'userLocationLat') {

            var userLocationLat = this.getCookie('userLocationLat');
            var userLocationLng = this.getCookie('userLocationLng');
            var userLocationCity = this.getCookie('userLocationCity');
            var userLocationCountry = this.getCookie('userLocationCountry');

        }
        else{
            var userLocationLat = localStorage.getItem('userLocationLat');
            var userLocationLng = localStorage.getItem('userLocationLng');
            var userLocationCity = localStorage.getItem('userLocationCity');
            var userLocationCountry = localStorage.getItem('userLocationCountry');

        }

        if(this.getCookie('pollenHeaderValue') != '' && this.getCookie('pollenHeaderValue') != null && this.getCookie('pollenHeaderValue') != 'pollenHeaderValue') {
            var pollenHeaderValue =  this.getCookie('pollenHeaderValue');
            var pollenHeaderValue_type =  this.getCookie('pollenHeaderValue_type');
        }
        else {
            var pollenHeaderValue =  localStorage.getItem('pollenHeaderValue');
            var pollenHeaderValue_type =  localStorage.getItem('pollenHeaderValue_type');
        }

        this.searchValue = pollenHeaderValue;

        pollenHeaderValue_type =  pollenHeaderValue_type || 'place.';

        if(!this.isRegionPage && !this.isCityPage && pollenHeaderValue && userLocationLat && userLocationLng && userLocationCity && userLocationCountry) {

            this.userLocation = {
                lat: userLocationLat,
                lng: userLocationLng,
            }
            this.searchValue = pollenHeaderValue;
            
        } else {

            if (userLocationLat && userLocationLng && userLocationCity && userLocationCountry) {
                this.userLocation = {
                    lat: parseFloat(userLocationLat),
                    lng: parseFloat(userLocationLng),
                };

                let pollenHeaderValue = `${userLocationCity}, ${userLocationCountry}`;
                this.setCookie('pollenHeaderValue', pollenHeaderValue, 30);
            }
            else{

                try {
                //ip stack update
                const response = await fetch(`https://api.ipstack.com/check?access_key=771c7cd15b294eb19b2e29264ff2b8c2&language=en`);
                const data = await response.json();

                if (data.country_name !== window.countryName) {
                    data.latitude = window.defaultUserLocation.lat;
                    data.longitude = window.defaultUserLocation.lng;
                    data.city = window.defaultCity;
                    data.country_name = window.countryName;
                }

                this.userLocation = {
                    lat: data.latitude,
                    lng: data.longitude,
                };

                this.setCookie('userLocationLat', parseFloat(data.latitude).toFixed(8), 30);
                this.setCookie('userLocationLng', parseFloat(data.longitude).toFixed(8), 30);
                this.setCookie('userLocationCity', data.city, 30);
                this.setCookie('userLocationCountry', data.country_name, 30);
                userLocationLat = data.latitude;
                userLocationLng = data.longitude;
                userLocationCity = data.city;
                userLocationCountry = data.country_name;

                let pollenHeaderValue = `${data.city}, ${data.country_name}`;
                
                this.setCookie('pollenHeaderValue', pollenHeaderValue, 30);

            } catch (e) {
                    this.userLocation = {
                        lat: window.defaultUserLocation.lat,
                        lng: window.defaultUserLocation.lng,
                    };
                    
                    let pollenHeaderValue = `${window.defaultCity}, ${window.countryName}`;
                    
                    this.setCookie('pollenHeaderValue', pollenHeaderValue, 30);
                    this.setCookie('userLocationLat',  window.defaultUserLocation.lat, 30);
                    this.setCookie('userLocationLng',  window.defaultUserLocation.lng, 30);
                    this.setCookie('userLocationCity', window.defaultCity, 30);
                    this.setCookie('userLocationCountry', window.countryName, 30);

                    console.error('IP stack API failed', e);
                }
            }            
        }

        if (!this.isRegionPage && !this.isCityPage && !this.params.search && userLocationCountry === window.countryName) {

            let response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${parseFloat(userLocationLng)},${parseFloat(userLocationLat)}.json?access_token=${window.mapBoxAPIKey}&language=${this.curLang}`);
            response = await response.json();

            let result = response.features.find(item => item.id.startsWith(pollenHeaderValue_type));
            // this.searchValue = result.place_name;
            this.params.search = result.place_name;
            this.bbox = result.bbox;
        }
    },

    async setSearchLocation() {

        if (this.searchValue) {

            let response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${this.searchValue}.json?access_token=${window.mapBoxAPIKey}`);
            response = await response.json();
            let result = response.features.find(item => item.id.startsWith('place.'));
            if (!result) result = response.features[0];
            this.userLocation = {
                lng: result.center[0],
                lat: result.center[1],
            };
            this.bbox = result.bbox;

            let type = result.id.split('.')[0];
            this.updateHeaderCity(result.place_name, result.center[0], result.center[1], type)
        }
    },

    async setCityLocation() {
        if (this.isCityPage) {
            this.userLocation = {
                lat: parseFloat(this.cityDivEl.getAttribute('data-latitude')),
                lng: parseFloat(this.cityDivEl.getAttribute('data-longitude')),
            };

            let response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${this.cityDivEl.getAttribute('data-value')}.json?access_token=${window.mapBoxAPIKey}`);
            response = await response.json();
            this.bbox = response.features[0].bbox;

            this.searchValue = this.cityDivEl.getAttribute('data-value');
        }
    },

    async setRegionLocation() {

        if (this.isRegionPage) {

            this.userLocation = {
                lat: parseFloat(this.regionSelectEl.getAttribute('data-latitude')),
                lng: parseFloat(this.regionSelectEl.getAttribute('data-longitude')),
            };

            let response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${this.regionSelectEl.getAttribute('data-name')}.json?access_token=${window.mapBoxAPIKey}`);
            response = await response.json();
            this.bbox = response.features[0].bbox;
        }
    },
    bindEvents() {

        document.querySelectorAll('[data-tab]').forEach(tabs => tabs.addEventListener('click', this.changeTabsPollen.bind(this)))
        document.querySelectorAll('[data-tabcontent]').forEach(tabs => tabs.addEventListener('click', this.changeTabs.bind(this)))
        document.querySelectorAll('[name="heatmap-pollen-type"]').forEach(heatmap => {

            heatmap.addEventListener('change', (e) => {

                this.tile = e.target.value;
                let tile = this.tile.toUpperCase();
                this.changeOverlay(`https://pollen.googleapis.com/v1/mapTypes/${tile}_UPI/heatmapTiles/{z}/{x}/{y}?key=${this.googlePollenApi}`);
            })
        });
        if (document.getElementById('pollen-region-select')) {
            document.getElementById('pollen-region-select').addEventListener('change', (event) => {
                let region = event.target.value;
                let url = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
                window.location.href = `${url}/${region}`;

            });
        }
        if (document.getElementById('pollen-city-select')) {
            document.getElementById('pollen-city-select').addEventListener('change', (event) => {
                let city = event.target.value;
                let url = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
                window.location.href = `${url}/${city}`;

            });
        }

    },
    setCookie(name, value, minutes) {
        window.dataLayer.forEach((elem) => {
            if (elem.event === "cookie_cat_marketing" || elem.action === "onAcceptAllServices") {
                let date = new Date();
                date.setTime(date.getTime() + (minutes * 60 * 1000));
                let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
                document.cookie = name + "=" + c_value;

                return document.cookie;
            }
        });
        localStorage.setItem(name, value);
    },    
    getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return unescape(cookie.substring(name.length + 1));
            }
        }
        return null; // Cookie not found
    },
    getPollenTranslation(text) {
        try {
            switch (text) {
                case 'pageUrl':
                    return (this.curLang == 'de' ? `/pages/pollenbelastung-heute` : this.curLang == 'fr' ? `/pages/charge-pollinique-aujourdhui` : this.curLang == 'it' ? `/pages/la-concentrazione-pollinica-oggi` : '');
                    break;
                case 'placeHolder':
                    return (this.curLang == 'de' ? `Stadt oder Adresse eingeben` : this.curLang == 'fr' ? `Saisir la ville ou l'adresse` : this.curLang == 'it' ? `Inserire città o indirizzo` : '');
                    break;
                case 'Sunday':
                    return (this.curLang == 'de' ? `Sonntag` : this.curLang == 'fr' ? `Dimanche` : this.curLang == 'it' ? `Domenica` : '');
                    break;
                case 'Monday':
                    return (this.curLang == 'de' ? `Montag` : this.curLang == 'fr' ? `Lundi` : this.curLang == 'it' ? `Lunedì` : '');
                    break;
                case 'Tuesday':
                    return (this.curLang == 'de' ? `Dienstag` : this.curLang == 'fr' ? `Mardi` : this.curLang == 'it' ? `Martedì` : '');
                    break;
                case 'Wednesday':
                    return (this.curLang == 'de' ? `Mittwoch` : this.curLang == 'fr' ? `Mercredi` : this.curLang == 'it' ? `Mercoledì` : '');
                    break;
                case 'Thursday':
                    return (this.curLang == 'de' ? `Donnerstag` : this.curLang == 'fr' ? `Jeudi` : this.curLang == 'it' ? `Giovedì` : '');
                    break;
                case 'Friday':
                    return (this.curLang == 'de' ? `Freitag` : this.curLang == 'fr' ? `Vendredi` : this.curLang == 'it' ? `Venerdì` : '');
                    break;
                case 'Saturday':
                    return (this.curLang == 'de' ? `Samstag` : this.curLang == 'fr' ? `Samedi` : this.curLang == 'it' ? `Sabato` : '');
                    break;               
                case 'NoValues':
                    return (this.curLang == 'de' ? `Keine Werte verfügbar` : this.curLang == 'fr' ? `Aucune valeur disponible` : this.curLang == 'it' ? `Nessun valore disponibile` : '');
                    break;               
                case 'veryLow':
                    return (this.curLang == 'de' ? `Sehr niedrig` : this.curLang == 'fr' ? `Très faible` : this.curLang == 'it' ? `Molto basso` : '');
                    break;               
                case 'low':
                    return (this.curLang == 'de' ? `Niedrig` : this.curLang == 'fr' ? `Faible` : this.curLang == 'it' ? `Basso` : '');
                    break;               
                case 'medium':
                    return (this.curLang == 'de' ? `Mittel` : this.curLang == 'fr' ? `Modéré` : this.curLang == 'it' ? `Medio` : '');
                    break;               
                case 'high':
                    return (this.curLang == 'de' ? `Hoch` : this.curLang == 'fr' ? `Elevé` : this.curLang == 'it' ? `Alto` : '');
                    break;               
                case 'veryHigh':
                    return (this.curLang == 'de' ? `Sehr hoch` : this.curLang == 'fr' ? `Très élevé` : this.curLang == 'it' ? `Molto alto` : '');
                    break;               
                case 'feelsLike':
                    return (this.curLang == 'de' ? `Gefühlte ` : this.curLang == 'fr' ? `On dirait ` : this.curLang == 'it' ? `Sembra ` : '');
                    break;               
                case 'source':
                    return (this.curLang == 'de' ? `Quelle ` : this.curLang == 'fr' ? `Source ` : this.curLang == 'it' ? `Fonte` : '');
                    break;               
            }

        } catch (e) {
            console.error(e);
        }
    }
}
window.pollen.init();
